// pages/KSB.js
import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import styles from './KSB.module.css';

// Prvi sloj - Naslov (sada je u glavnoj komponenti)
// Drugi sloj - Podmeni
const SubMenu = () => {
  const location = useLocation();
  
  const subMenuItems = [
    { name: 'Procjena vrijednosti kompanije', path: '/ksb' },
    { name: 'Mandat za pronalazak kupca kompanije', path: '/ksb/priprema' },
    { name: 'Povećanje vrijednosti kompanije', path: '/ksb/procjena' },
  ];

  return (
    <nav className={styles.subMenuLayer}>
      <div className={styles.contentContainer}>
        <ul className={styles.subMenuList}>
          {subMenuItems.map((item) => (
            <li key={item.path}>
              <Link 
                to={item.path}
                className={`${styles.subMenuLink} ${
                  location.pathname === item.path ? styles.activeSub : ''
                }`}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

// Treći sloj - Sadržaj za Krvna slika biznisa
const ProcjenaVrijednosti = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.contentContainer}>
        <div className={styles.mentorstvoGrid}>
          <div className={styles.mentorstvoCard}>
            <h2>Šta uključuje?</h2>
            <ul>
              <li>Analiza izvještaja i izrada racio brojeva poslovanja</li>
              <li>Prijedlog poboljšanja sa kvantifikacijama</li>
              <li>Konkretne akcije i definisanje KPI</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const Mandat = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.contentContainer}>
        <div className={styles.mentorstvoGrid}>
          <div className={styles.mentorstvoCard}>
            <h2>Koraci u pripremi</h2>
            <ul>
              <li>Due diligence priprema</li>
              <li>Finansijsko čišćenje</li>
              <li>Pravna dokumentacija</li>
              <li>Operativna optimizacija</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const PovecanjeVrijednosti = () => {
  return (
    <div className={styles.pageContent}>
      <div className={styles.contentContainer}>
        <div className={styles.mentorstvoGrid}>
          <div className={styles.mentorstvoCard}>
            <h2>Metodologije procjene</h2>
            <ul>
              <li>Metoda diskontovanog novčanog toka (DCF)</li>
              <li>Metoda tržišnih multiplikatora</li>
              <li>Metoda knjigovodstvene vrijednosti</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
// Glavna KSB komponenta
const KSB = () => {
  return (
    <div className={styles.ksbWrapper}>
      {/* Placeholder za fixed header */}
      <div className={styles.headerPlaceholder} />
      
      {/* Prvi sloj - Naslov */}
      <div className={styles.titleLayer}>
        <div className={styles.contentContainer}>
          <h1 className={styles.pageTitle}>Prodaja kompanije</h1>
        </div>
      </div>
      
      {/* Drugi sloj - Podmeni */}
      <SubMenu />
      
      {/* Treći sloj - Sadržaj */}
      <Routes>
        <Route path="/" element={<ProcjenaVrijednosti />} />
        <Route path="priprema" element={<Mandat />} />
        <Route path="procjena" element={<PovecanjeVrijednosti />} />
      </Routes>
    </div>
  );
};

export default KSB;